<div class="responsive-card d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column gap-2">
    <div class="responsive-card-title" i18n>Lump Sum Payment</div>
    <div class="responsive-card-description" i18n>Choose a date and amount for a one-time payment.</div>
  </div>
  <app-primary-button
    *ngIf="!(displayLumpSumForm$ | async)"
    [size]="BaseButtonSizeEnum.xs"
    (buttonClicked)="showLumpSumForm()"
    i18n>
    Add Lump Sum Payment
  </app-primary-button>
  <ng-container *ngIf="displayLumpSumForm$ | async">
    <div class="lump-sum-grid" [formGroup]="paymentStepForm">
      <!-- label row  -->
      <label
        class="form-input-label"
        [for]="'lumpSumPaymentAmount'"
        [class.disabled]="paymentStepForm.controls.lumpSumPaymentAmount.disabled"
        i18n>
        Payment Amount
      </label>
      <label
        class="form-input-label"
        [for]="'lumpSumPaymentMonth'"
        [class.disabled]="paymentStepForm.controls.lumpSumPaymentMonth.disabled"
        i18n>
        Payment Start Month
      </label>
      <label
        class="form-input-label"
        [for]="'lumpSumPaymentYear'"
        [class.disabled]="paymentStepForm.controls.lumpSumPaymentYear.disabled"
        i18n>
        Payment Year
      </label>
      <div></div>

      <!-- input/button row  -->
      <app-currency-input
        controlId="lumpSumPaymentAmount"
        formControlName="lumpSumPaymentAmount"
        [error]="
          (formSubmitted || paymentStepForm.controls.lumpSumPaymentAmount.dirty) &&
          paymentStepForm.controls.lumpSumPaymentAmount.invalid
        " />

      <app-dropdown-input
        controlId="lumpSumPaymentMonth"
        formControlName="lumpSumPaymentMonth"
        [placeholder]="''"
        [dropdowns]="monthDropdowns"
        [error]="
          (formSubmitted ||
            paymentStepForm.controls.lumpSumPaymentMonth.dirty ||
            paymentStepForm.controls.lumpSumPaymentYear.dirty) &&
          paymentStepForm.controls.lumpSumPaymentMonth.invalid
        " />
      <app-dropdown-input
        controlId="lumpSumPaymentYear"
        formControlName="lumpSumPaymentYear"
        [placeholder]="''"
        [dropdowns]="yearDropdowns"
        [error]="
          (formSubmitted || paymentStepForm.controls.lumpSumPaymentYear.dirty) &&
          paymentStepForm.controls.lumpSumPaymentYear.invalid
        " />
      <button
        class="no-style-button"
        aria-label="Remove lump sum payment"
        i18n-aria-label
        (click)="deleteLumpSumPaymentInfo()">
        <img src="assets/icons/grey/Trash.svg" alt="" [style.height.rem]="1.5" [style.width.rem]="1.5" />
      </button>

      <!-- error row  -->
      <app-form-error
        *ngIf="
          (formSubmitted || paymentStepForm.controls.lumpSumPaymentAmount.dirty) &&
          paymentStepForm.controls.lumpSumPaymentAmount.invalid
        "
        class="payment-error"
        [errors]="paymentStepForm.controls.lumpSumPaymentAmount.errors"
        [customErrorMessages]="customErrorMessages.lumpSumPaymentAmount" />
      <app-form-error
        *ngIf="
          (formSubmitted ||
            paymentStepForm.controls.lumpSumPaymentMonth.dirty ||
            paymentStepForm.controls.lumpSumPaymentYear.dirty) &&
          paymentStepForm.controls.lumpSumPaymentMonth.invalid
        "
        class="month-error"
        [errors]="paymentStepForm.controls.lumpSumPaymentMonth.errors"
        [customErrorMessages]="customErrorMessages.lumpSumPaymentMonth" />
      <app-form-error
        *ngIf="
          (formSubmitted || paymentStepForm.controls.lumpSumPaymentYear.dirty) &&
          paymentStepForm.controls.lumpSumPaymentYear.invalid
        "
        class="year-error"
        [errors]="paymentStepForm.controls.lumpSumPaymentYear.errors"
        [customErrorMessages]="customErrorMessages.lumpSumPaymentYear" />
    </div>
  </ng-container>
</div>
